import { EInstallTestState } from "~domain/install-tests/models/install-test-state-model.ts";

const testInstallStatus: Record<EInstallTestState, string> = {
  [EInstallTestState.OK]: "Ok",
  [EInstallTestState.NOK]: "Nok",
  [EInstallTestState.UNKNOWN]: "Inconnu",
};

export const V2_V5_TESTS_TABLE_FRENCH_LOCALE = {
  searchPlaceholder: "Rechercher une valeur...",
  noTestFound: "Aucun test trouvé...",
  headers: {
    testId: "Test Id",
    testDate: "Date",
    target: "Test",
    measuredPower: "Puissance mesurée",
    result: "Résultat",
    resultDetails: "Détails du résultat",
    modulatorHwId: "Modulateur Hw Id",
    modulatorCsId: "Modulateur Cs Id",
    pilotHwId: "Pilote hw Id",
    testTester: "Testeur",
  },
  filters: {
    placeholders: {
      testId: "Rechercher par test id...",
      testDate: "Rechercher par date...",
      target: "Rechercher par test...",
      measuredPower: "Rechercher par puissance...",
      result: "Rechercher par résultat...",
      modulatorHwId: "Rechercher par modulateur hw id...",
      modulatorCsId: "Rechercher par modulateur cs id...",
      pilotHwId: "Rechercher par pilote hw id...",
      testTester: "Rechercher par testeur...",
    },
  },
  testInstallStatus: testInstallStatus,
};
